import { createContext } from 'react';

import type { TBillingAttributes } from '@shared/dream-components';

/**
 * Logic layer for the subscriber's **personal** billing surface on the General tab — the
 * `BillingElement` (invoice history, payment method / billing details, "update billing" →
 * Stripe customer portal). Self-calls the billing slice of `useCurrentPlan` (deduped with
 * SubscriptionActions' call via the React-Query cache), shapes the raw summary/details into the
 * `BillingElement` data payload, and exposes it + the update-billing opener via context. Holds
 * no UI; the colocated `BillingSection` child renders straight from `billingData`. Subscription
 * lifecycle (downgrade / change-plan / proration) lives in `SubscriptionActionsProvider`, and
 * the admin / group billing fan-out is its own domain (`AdminBillingProvider`) — both stay out.
 */
export type BillingContextType = {
  showBillingDetails: boolean;
  isLoadingBillingSummary: boolean;
  isUpdateButtonDisabled: boolean;
  billingData: TBillingAttributes['data'];
  trialDurationLabel: string;
  onClickUpdateBilling: () => void;
};

export const BillingContext = createContext<BillingContextType | undefined>(undefined);
BillingContext.displayName = 'BillingContext';
